import React from 'react';

import { ItemsSummaryProps } from './ItemsSummary.props';

import ItemsView from './ItemsSummary.view';

const ItemsSummaryContainer = (props: ItemsSummaryProps) => {
  return <ItemsView />;
};

export default ItemsSummaryContainer;
